// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgImage24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect x={5} y={5} width={14} height={14} rx={2} stroke="#323338" strokeWidth={1.5} />
				<rect x={7.625} y={7.625} width={3.5} height={3.5} rx={1.75} stroke="#323338" />
				<path
					d="M5 17.25L8.84476 13.3683C9.0404 13.1707 9.3596 13.1707 9.55524 13.3683L10.7114 14.5356C10.9071 14.7331 11.2263 14.7331 11.4219 14.5356L14.4448 11.4837C14.6404 11.2861 14.9596 11.2861 15.1552 11.4837L19 15.3654"
					stroke="#323338"
					strokeWidth={1.5}
					strokeLinejoin="round"
				/>
			</Svg>
		);
	}
);
SvgImage24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgImage24;
